import React, { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import './AlertNotification.css';

const AlertNotification = ({ message, variant = 'success', onClose, autoCloseDelay = 5000 }) => {
  useEffect(() => {
    if (message && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [message, autoCloseDelay, onClose]);

  if (!message) return null;

  return (
    <div className="alert-notification-container">
      <Alert 
        variant={variant} 
        dismissible 
        onClose={onClose}
        className="alert-notification"
      >
        {message}
      </Alert>
    </div>
  );
};

export default AlertNotification;
